import React, { useEffect } from "react"
import { Route, Redirect } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { triggerAction } from "../../store/constants"
import { handleSocketConnection } from "../../store/actions/auth"
import Cookies from 'js-cookie'

export const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { user } = useSelector((state) => ({
    user: state.user,
  }))
  const dispatch = useDispatch()
  let isValid = user && user.token

  useEffect(() => {
    if (!isValid && localStorage.getItem("token")) {
      dispatch(
        triggerAction("SET_USER_DATA", {
          ...user,
          token: Cookies.get('token'),
          tokenBC: Cookies.get('tokenBC'),
        }),
      )
    }
  }, [isValid, dispatch, user])

  useEffect(() => {
    const uConnected = localStorage.getItem("uconnected")
    if (user && user.id && !uConnected) {
      dispatch(handleSocketConnection("connected", user.id))
      localStorage.setItem("uconnected", "true")
    }
  }, [user, dispatch])

  if (!isValid && localStorage.getItem("token")) {
    isValid = true
  }
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isValid && "/" !== props.location.pathname) {
          return (
            <Redirect
              to={{
                pathname: "/",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        } else if (isValid && "/" === props.location.pathname) {
          return (
            <Redirect
              to={{
                pathname: "/Groups",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        } else {
          return <Component {...props} />
        }
      }}
    />
  )
}
ProtectedRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.func, PropTypes.object]),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
}
export default ProtectedRoute
